(function () {
    'use strict';

    angular.module("imApp").factory("p2StatSourceService", ['$ihttp', function ($ihttp) {
        let service = {
            listStatSources: function (parms) {
                return $ihttp.post({
                    method: 810,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
